import { useEffect, useState } from 'react';
import { Icon } from './Icons.jsx';

// Modal de visualização do pedido enviado. Mostra a imagem em tela cheia,
// alternando entre "ajustar à tela" e "tamanho real" (largura total com
// rolagem própria) para ler os detalhes — útil sobretudo no celular.
export default function ImagePreviewModal({ src, title, onClose }) {
  const [zoomed, setZoomed] = useState(false);

  // Enquanto o modal está aberto, trava a rolagem do fundo (evita o "scroll
  // duplo" no celular) e fecha no ESC.
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return (
    <div
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, zIndex: 1100, background: 'var(--overlay-black-92)', display: 'flex', flexDirection: 'column' }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', color: 'var(--white)', flexShrink: 0 }}>
        <div style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 15, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginRight: 12 }}>
          {title || 'Pedido médico'}
        </div>
        <button onClick={onClose} aria-label="Fechar" style={{ color: 'var(--white)', padding: 6, flexShrink: 0 }}>
          <Icon.x size={22} color="var(--white)"/>
        </button>
      </div>

      {/* Container com rolagem própria: no modo ampliado a imagem ocupa a
          largura toda e rola dentro daqui, sem afetar a página por trás. */}
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ flex: 1, overflow: 'auto', WebkitOverflowScrolling: 'touch', display: 'flex', alignItems: zoomed ? 'flex-start' : 'center', justifyContent: 'center', padding: zoomed ? 0 : 16 }}
      >
        <img
          src={src}
          alt={title || ''}
          onClick={() => setZoomed(z => !z)}
          style={zoomed
            ? { width: '100%', height: 'auto', display: 'block', cursor: 'zoom-out' }
            : { maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', display: 'block', cursor: 'zoom-in' }}
        />
      </div>

      <div style={{ padding: '10px 16px 22px', textAlign: 'center', color: 'var(--overlay-white-70)', fontSize: 12, flexShrink: 0 }}>
        Toque na imagem para {zoomed ? 'ajustar à tela' : 'ampliar'}
      </div>
    </div>
  );
}
